import $ from 'lib/jquery.ui';

var regex = {
  trailingSlash: /\/+$/
};

function form() {
  return $('.ngp-form');
}

function url() {
  var u = form().data('fastactionEndpoint') || 'https://fastaction.ngpvan.com';
  return u.replace(regex.trailingSlash, '');
}

export default {
  urls: {
    base: url
  }
};
